import { OPTIMIZELY_FLAGS_ENUM } from '@/constants'
import { OptimizelyDecisionsProps } from '@/context/optimizely-decisions-context'

export type PropertiesNearbyVariant = 'variant_a'

export const resolvePropertiesNearbyVariant = (
  optiContext: OptimizelyDecisionsProps,
): PropertiesNearbyVariant | null => {
  if (optiContext.isGuestApp) {
    return null
  }

  const variation = optiContext.getExperimentVariationKey(
    OPTIMIZELY_FLAGS_ENUM.ONESEARCH_EXPANDED_POLYGON,
  )

  return variation === 'variant_a' ? 'variant_a' : null
}
